const formatDate = value => {
  const [year, month, day] = value.split("-").map(Number)
  const monthLabel = new Intl.DateTimeFormat("en-GB", {
    month: "short",
    timeZone: "UTC",
  }).format(new Date(Date.UTC(year, month - 1, day)))
  return { year, month, day, monthLabel }
}

export const formatRange = ({ startDate, endDate }) => {
  const start = formatDate(startDate)
  const end = formatDate(endDate)
  if (start.year === end.year && start.month === end.month) {
    return `${start.day}–${end.day} ${end.monthLabel} ${end.year}`
  }
  if (start.year === end.year) {
    return `${start.day} ${start.monthLabel}–${end.day} ${end.monthLabel} ${end.year}`
  }
  return `${start.day} ${start.monthLabel} ${start.year}–${end.day} ${end.monthLabel} ${end.year}`
}

export const formatTimestamp = value => new Intl.DateTimeFormat("en-GB", {
  dateStyle: "medium",
  timeStyle: "short",
  timeZone: "Europe/Bucharest",
}).format(new Date(value))

// Event Participation Frequency (events-per-event-participant) and the previous
// Participation Frequency unit, still sent by an API without Event Participation Frequency.
export const isFrequencyUnit = unit => (
  unit === "events-per-event-participant" || unit === "participations-per-event-participant"
)

// Whether a change is good news: a lower-is-better metric (withdrawals, churn) improves when it falls.
export const isImprovement = (metric, change) => (
  metric?.polarity === "lower-is-better" ? change <= 0 : change >= 0
)

export const percentageLabel = value => {
  if (value === null || value === undefined) return "No comparable baseline"
  return `${value > 0 ? "+" : ""}${value.toFixed(1)}%`
}

export const formatMoney = (value, currency = "RON") => {
  if (value === null || value === undefined) return "Unavailable"
  return `${Number(value).toLocaleString("en-GB", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${currency}`
}

export const formatBusinessDate = value => {
  if (!value) return "Unavailable"
  const [year, month, day] = value.split("-").map(Number)
  return new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  }).format(new Date(Date.UTC(year, month - 1, day)))
}
